import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;
export const contentSettingsConfirmationContainerCss = {
  position: "fixed",
  bottom: 0,
  width: "100%",
  zIndex: 100,
  "& > aside": {
    marginBottom: 0,
    "& > div": {
      margin: 2,
      width: "100%",
    },
    "& > div > div": {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      paddingRight: 0,
    },
  },
};

export const contentSettingsCancelButtonCss = {
  marginRight: 16,
};

export const contentSettingsButtonGroupCss = {
  "& > div": {
    display: "inline-flex",
  },
};

export const confirmationModalCss = {
  root: {
    zIndex: 15,
    [mq.downTo(xs)]: {
      "& > div": {
        height: "242px",
      },
    },
  },
};

export const confirmationModalButtonsCss = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 16,
};
